import { useEffect } from "react";

export const SITE = "https://kimkornachuk.com";
export const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/009c1cbf-3a4d-4247-a75d-168f78fdaaf3/images/5fe29dd9de4217601eb81c67d2153b544855f6959db6163a3989573bc069d52d.jpeg";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "", image, type = "website", jsonLd }) {
  useEffect(() => {
    const url = SITE + path;
    const img = image || DEFAULT_OG;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, path, image, type]);

  if (!jsonLd) return null;
  const safeJson = JSON.stringify(jsonLd).replace(/</g, "\\u003c");
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJson }} />;
}
